// Parser periode tagihan dari field aktual e-Billing `periode_belum_lunas`
// (dapat berupa string, objek, atau array objek). TIDAK menebak: elemen yang tidak
// dapat diurai ditandai invalid dan tidak dapat dipilih.
export const MONTHS = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
const LABEL_KEYS = ["periode", "periode_tagihan", "bulan_tahun", "nama_periode", "period", "tgl_tagihan", "tanggal_tagihan"];
const NOMINAL_KEYS = ["nominal", "nominal_tagihan", "tagihan", "jumlah", "total", "harga", "amount"];
const STATUS_KEYS = ["status_pembayaran", "status_bayar", "status", "keterangan"];

// "Oktober 2026" | "2026-10" | "2026-10-05" | "10/2026" (+tahun terpisah) -> "Oktober 2026"; lainnya -> null
export function normalizePeriode(value, tahun) {
  const s = String(value ?? "").trim();
  if (!s) return null;
  let m = s.match(/^(\d{4})-(\d{1,2})(?:-\d{1,2})?/);
  if (m && +m[2] >= 1 && +m[2] <= 12) return `${MONTHS[+m[2] - 1]} ${m[1]}`;
  m = s.match(/^(\d{1,2})\/(\d{4})$/);
  if (m && +m[1] >= 1 && +m[1] <= 12) return `${MONTHS[+m[1] - 1]} ${m[2]}`;
  m = s.toLowerCase().match(/^([a-z]+)\s+(\d{4})$/);
  const idx = (name) => MONTHS.findIndex((x) => x.toLowerCase() === name);
  if (m && idx(m[1]) >= 0) return `${MONTHS[idx(m[1])]} ${m[2]}`;
  const ty = String(tahun ?? "").trim();
  if (/^\d{4}$/.test(ty)) {
    if (idx(s.toLowerCase()) >= 0) return `${MONTHS[idx(s.toLowerCase())]} ${ty}`;
    if (/^\d{1,2}$/.test(s) && +s >= 1 && +s <= 12) return `${MONTHS[+s - 1]} ${ty}`;
  }
  return null;
}

const pickKey = (o, keys) => { for (const k of keys) { if (o[k] !== undefined && o[k] !== null && o[k] !== "") return o[k]; } return undefined; };
const toNum = (v) => { const n = parseInt(String(v ?? "").replace(/[^\d]/g, ""), 10); return Number.isFinite(n) && n > 0 ? n : null; };

export function parsePeriods(raw) {
  const src = raw?.periode_belum_lunas;
  if (src === undefined || src === null || src === "") return [];
  const list = Array.isArray(src) ? src : [src];
  const out = list.map((el) => {
    let label = null, nominal = null, statusText = "";
    if (el && typeof el === "object") {
      label = normalizePeriode(pickKey(el, LABEL_KEYS), el.tahun);
      if (!label && el.bulan !== undefined) label = normalizePeriode(el.bulan, el.tahun);
      nominal = toNum(pickKey(el, NOMINAL_KEYS));
      statusText = String(pickKey(el, STATUS_KEYS) ?? "");
    } else {
      label = normalizePeriode(el);
    }
    const st = statusText.toLowerCase();
    const lunas = st.includes("lunas") && !st.includes("belum");
    return { label, nominal, lunas, statusText, valid: !!label, rawText: typeof el === "object" ? JSON.stringify(el) : String(el) };
  });
  // nominal dari level tagihan hanya bila sumber tepat 1 periode (sumber data jelas, bukan tebakan)
  if (out.length === 1 && out[0].nominal == null) out[0].nominal = toNum(raw?.nominal_tagihan);
  return out;
}
